import createIcon from '../../createIcon';

/**
 * @component @name BorderRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAyMUg5VjE5SDdWMjFaTTMgNUg1VjNIM1Y1Wk03IDVIOVYzSDdWNVpNNyAxM0g5VjExSDdWMTNaTTMgMjFINVYxOUgzVjIxWk0xMSAyMUgxM1YxOUgxMVYyMVpNMyAxM0g1VjExSDNWMTNaTTMgMTdINVYxNUgzVjE3Wk0zIDlINVY3SDNWOVpNMTEgMTdIMTNWMTVIMTFWMTdaTTE1IDEzSDE3VjExSDE1VjEzWk0xOSAzVjIxSDIxVjNIMTlaTTE1IDIxSDE3VjE5SDE1VjIxWk0xNSA1SDE3VjNIMTVWNVpNMTEgMTNIMTNWMTFIMTFWMTNaTTExIDVIMTNWM0gxMVY1Wk0xMSA5SDEzVjdIMTFWOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderRight = createIcon('BorderRight', [
  [
    'path',
    {
      d: 'M7 21H9V19H7V21ZM3 5H5V3H3V5ZM7 5H9V3H7V5ZM7 13H9V11H7V13ZM3 21H5V19H3V21ZM11 21H13V19H11V21ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM11 17H13V15H11V17ZM15 13H17V11H15V13ZM19 3V21H21V3H19ZM15 21H17V19H15V21ZM15 5H17V3H15V5ZM11 13H13V11H11V13ZM11 5H13V3H11V5ZM11 9H13V7H11V9Z',
      key: '1udto5',
    },
  ],
]);

export default BorderRight;
